<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             size="lg"
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <label><strong>Emitente Documento</strong></label>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>Tipo *</label>
                      <b-form-group>
                        <b-form-radio-group
                          v-model="helpForm.emi_tp_pessoa"
                          :options="optionsLivTpPessoa"
                          plain
                          @input="ajustaMascara(1, 1)"
                        ></b-form-radio-group>
                        <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                      </b-form-group>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_tp_pessoa')" v-if="helpForm.errors.has('emi_tp_pessoa')"></b-form-feedback>
                    </b-col>

                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                        <label>CNPJ/CPF</label>
                        <b-form-input type="text"
                                      placeholder="CNPJ/CPF"
                                      v-mask="mascaraEmiNfe"
                                      v-model="helpForm.emi_cnpj_cpf_cuit"
                                      @input="
                                        helpForm.emi_cnpj_cpf_cuit = sanitizeDocPessoa(
                                          helpForm.emi_cnpj_cpf_cuit
                                        )
                                      "
                                      >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_cnpj_cpf_cuit')" v-if="helpForm.errors.has('emi_cnpj_cpf_cuit')"></b-form-feedback>
                    </b-col>
                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                        <label>IE</label>
                        <b-form-input type="text"
                                      placeholder="IE"
                                      v-model="helpForm.emi_ie"
                                      >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_ie')" v-if="helpForm.errors.has('emi_ie')"></b-form-feedback>
                    </b-col>
                    <b-col sm="6" md="6" class="m-t-5px p-a-0">
                        <label>Nome</label>
                        <b-form-input type="text"
                                    placeholder="Nome"
                                    v-model="helpForm.emi_nome"
                                    >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_nome')" v-if="helpForm.errors.has('emi_nome')"></b-form-feedback>
                    </b-col>
                </b-row>
                <div class="loadingDataPositionEndereco">
                <div class="loadingData" v-if="loadingCepEmi"><div class="loadingDataSpinner"><spinner v-if="loadingCepEmi" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                    <b-row no-gutters>
                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>CEP *</label>
                          <b-form-input type="text"
                                        placeholder="CEP"
                                        @change="getCep(1)"
                                        v-mask="'#####-###'"
                                        v-model="helpForm.emi_cep"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_cep')" v-if="helpForm.errors.has('emi_cep')"></b-form-feedback>
                        </b-col>

                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>Municipio *</label>
                          <multiselect v-model="helpForm.emi_municipio"
                          :options="optionsMunicipios"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_municipio.value')" v-if="helpForm.errors.has('emi_municipio.value')"></b-form-feedback>
                        </b-col>


                        <b-col sm="3" md="3" class="m-t-5px p-a-0">
                          <label>Endereço *</label>
                          <b-form-input type="text"
                                        placeholder="Endereço"
                                        v-model="helpForm.emi_endereco"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_endereco')" v-if="helpForm.errors.has('emi_endereco')"></b-form-feedback>
                        </b-col>

                        <b-col sm="1" md="1" class="m-t-5px p-a-0">
                          <label>Número *</label>
                          <b-form-input type="text"
                                        placeholder="Número"
                                        v-model="helpForm.emi_numero"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_numero')" v-if="helpForm.errors.has('emi_numero')"></b-form-feedback>
                        </b-col>

                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>Bairro *</label>
                          <b-form-input type="text"
                                        placeholder="Bairro"
                                        v-model="helpForm.emi_bairro"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_bairro')" v-if="helpForm.errors.has('emi_bairro')"></b-form-feedback>
                        </b-col>

                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>Complemento</label>
                          <b-form-input type="text"
                                        placeholder="Complemento"
                                        v-model="helpForm.emi_complemento"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_complemento')" v-if="helpForm.errors.has('emi_complemento')"></b-form-feedback>
                        </b-col>
                    </b-row>
                </div>
                <b-row no-gutters>
                    <label><strong>Destinatário Documento</strong></label>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>Tipo *</label>
                      <b-form-group>
                        <b-form-radio-group
                          v-model="helpForm.des_tp_pessoa"
                          :options="optionsLivTpPessoa"
                          plain
                          @input="ajustaMascara(2, 1)"
                        ></b-form-radio-group>
                        <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                      </b-form-group>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_tp_pessoa')" v-if="helpForm.errors.has('des_tp_pessoa')"></b-form-feedback>
                    </b-col>

                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                        <label>CNPJ/CPF</label>
                        <b-form-input type="text"
                                      placeholder="CNPJ/CPF"
                                      v-mask="mascaraDesNfe"
                                      v-model="helpForm.des_cnpj_cpf_cuit"
                                      @input="
                                        helpForm.des_cnpj_cpf_cuit = sanitizeDocPessoa(
                                          helpForm.des_cnpj_cpf_cuit
                                        )
                                      "
                                      >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_cnpj_cpf_cuit')" v-if="helpForm.errors.has('des_cnpj_cpf_cuit')"></b-form-feedback>
                    </b-col>
                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                        <label>IE</label>
                        <b-form-input type="text"
                                      placeholder="IE"
                                      v-model="helpForm.des_ie"
                                      >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_ie')" v-if="helpForm.errors.has('des_ie')"></b-form-feedback>
                    </b-col>
                    <b-col sm="4" md="4" class="m-t-5px p-a-0">
                        <label>Nome</label>
                        <b-form-input type="text"
                                    placeholder="Nome"
                                    v-model="helpForm.des_nome"
                                    >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_nome')" v-if="helpForm.errors.has('des_nome')"></b-form-feedback>
                    </b-col>
                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>PIN Suframa</label>
                      <b-form-input type="text"
                                    placeholder="PIN"
                                    v-model="helpForm.des_pin"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_pin')" v-if="helpForm.errors.has('des_pin')"></b-form-feedback>
                    </b-col>
                </b-row>
                <div class="loadingDataPositionEndereco">
                    <div class="loadingData" v-if="loadingCepDes"><div class="loadingDataSpinner"><spinner v-if="loadingCepDes" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                    <b-row no-gutters>
                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>CEP *</label>
                          <b-form-input type="text"
                                        placeholder="CEP"
                                        @change="getCep(2)"
                                        v-mask="'#####-###'"
                                        v-model="helpForm.des_cep"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_cep')" v-if="helpForm.errors.has('des_cep')"></b-form-feedback>
                        </b-col>

                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>Municipio *</label>
                          <multiselect v-model="helpForm.des_municipio"
                          :options="optionsMunicipios"
                          track-by="value"
                          label="label"
                          :hide-selected="true"
                          placeholder="Selecione"
                          tag-placeholder="Selecionar"
                          select-label="Selecionar"
                          selected-label="Selecionado"
                          deselect-label="Remover"
                          ></multiselect>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_municipio.value')" v-if="helpForm.errors.has('des_municipio.value')"></b-form-feedback>
                        </b-col>


                        <b-col sm="3" md="3" class="m-t-5px p-a-0">
                          <label>Endereço *</label>
                          <b-form-input type="text"
                                        placeholder="Endereço"
                                        v-model="helpForm.des_endereco"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_endereco')" v-if="helpForm.errors.has('des_endereco')"></b-form-feedback>
                        </b-col>

                        <b-col sm="1" md="1" class="m-t-5px p-a-0">
                          <label>Número *</label>
                          <b-form-input type="text"
                                        placeholder="Número"
                                        v-model="helpForm.des_numero"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_numero')" v-if="helpForm.errors.has('des_numero')"></b-form-feedback>
                        </b-col>

                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>Bairro *</label>
                          <b-form-input type="text"
                                        placeholder="Bairro"
                                        v-model="helpForm.des_bairro"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_bairro')" v-if="helpForm.errors.has('des_bairro')"></b-form-feedback>
                        </b-col>

                        <b-col sm="2" md="2" class="m-t-5px p-a-0">
                          <label>Complemento</label>
                          <b-form-input type="text"
                                        placeholder="Complemento"
                                        v-model="helpForm.des_complemento"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_complemento')" v-if="helpForm.errors.has('des_complemento')"></b-form-feedback>
                        </b-col>
                    </b-row>
                </div>

                <b-row no-gutters>
                    <label><strong>Detalhes</strong></label>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>Tipo *</label>
                      <multiselect v-model="helpForm.tp_doc"
                      :options="optionsLivDocFiscalTpDoc"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('tp_doc.value')" v-if="helpForm.errors.has('tp_doc.value')"></b-form-feedback>
                    </b-col>

                  <b-col sm="1" md="1" class="m-t-5px p-a-0">
                      <label>Nº Fiscal *</label>
                      <b-form-input type="text"
                                    placeholder="Nº Fiscal"
                                    v-model="helpForm.num_fiscal"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('num_fiscal')" v-if="helpForm.errors.has('num_fiscal')"></b-form-feedback>
                  </b-col>

                  <b-col sm="1" md="1" class="m-t-5px p-a-0">
                      <label>Série *</label>
                      <b-form-input type="text"
                                    placeholder="Série"
                                    v-model="helpForm.serie"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('serie')" v-if="helpForm.errors.has('serie')"></b-form-feedback>
                  </b-col>

                  <b-col sm="1" md="1" class="m-t-5px p-a-0">
                      <label>Chave</label>
                      <b-form-input type="text"
                                    placeholder="Chave"
                                    v-model="helpForm.chave"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                  </b-col>

                  <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>Data *</label>
                       <input type="text" placeholder="Data" class="form-control" v-mask="'##/##/####'" v-model="helpForm.dt_emissao" @keyup.enter="doFilter">
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('dt_emissao')" v-if="helpForm.errors.has('dt_emissao')"></b-form-feedback>
                  </b-col>

                  <b-col sm="1" md="1" class="m-t-5px p-a-0">
                      <label>Volume *</label>
                      <b-form-input type="text"
                                    placeholder="Volume"
                                    v-model="helpForm.qtd_volume"
                                    >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('qtd_volume')" v-if="helpForm.errors.has('qtd_volume')"></b-form-feedback>
                  </b-col>

                  <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>Peso Bruto *</label>
                      <currency-input
                          class="form-control"
                          v-model="helpForm.peso_bruto"
                          placeholder=""

                          :precision="3"
                          :locale="getCurrency.locale"
                          style="text-align: right"
                          v-on:keyup="calcCte"
                          :currency="{ prefix: 'KG '}"
                          :distraction-free="getCurrency"/>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('peso_bruto')" v-if="helpForm.errors.has('peso_bruto')"></b-form-feedback>
                  </b-col>

                  <b-col sm="2" md="2" class="m-t-5px p-a-0">
                      <label>Valor Doc. *</label>
                      <currency-input
                          class="form-control"
                          v-model="helpForm.vlr_total_nfe"
                          placeholder=""

                          :auto-decimal-mode="true"
                          :locale="getCurrency.locale"
                          style="text-align: right"
                          v-on:keyup="calcCte"
                          :currency="{ prefix: 'R$ '}"
                          :distraction-free="getCurrency"/>
                      <b-form-feedback class="text-danger" v-text="helpForm.errors.get('vlr_total_nfe')" v-if="helpForm.errors.has('vlr_total_nfe')"></b-form-feedback>
                  </b-col>
                 </b-row>
                 <b-row>
                     <b-col sm="10" md="10">
                     </b-col>
                     <b-col sm="2" md="2" class="text-right">
                         <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocDigitacao($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                         Adicionar
                         </b-btn>
                     </b-col>
                 </b-row>
             </b-container>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from './AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      loadingCepEmi: false,
      loadingCepDes: false,
      loadingAddDoc: false,
      statusSelected: [],
      optionsLivTpPessoa: [],
      optionsLivDocFiscalTpDoc: [],
      optionsMunicipios: [],
      errors_array: [],
      mascaraEmiNfe: "###.###.###-##",
      mascaraDesNfe: "###.###.###-##",
      mascaraDesCte: "###.###.###-##",
      form: new Form({ cd: '',
                       descr: '',
                       param_id: '',
                       status: '',
                   }),
   form_doctransp: new Form({ doctransp: []
                             , chave: ''
                             , emi_cnpj_cpf_cuit: ''
                             , emi_ie: ''
                             , emi_nome: ''
                             , emi_cep: ''
                             , emi_numero: ''
                             , emi_bairro: ''
                             , emi_endereco: ''
                             , emi_municipio: []
                             , emi_complemento: ''
                             , des_tp_pessoa: ''
                             , des_cnpj_cpf_cuit: ''
                             , des_ie: ''
                             , des_nome: ''
                             , des_cep: ''
                             , des_numero: ''
                             , des_bairro: ''
                             , des_endereco: ''
                             , des_municipio: []
                             , des_complemento: ''
                             , des_pin: ''
                             , tp_doc: []
                             , num_fiscal: ''
                             , serie: ''
                             , dt_emissao: ''
                             , qtd_volume: ''
                             , peso_bruto: 0
                             , vlr_total_cte: 0
                             , cep_busca: ''}),
     helpForm: new Form({statusRecord: [], bcliente_id_active: '', params: [],search:'', docs: []
                       , chave: ''
                       , emi_tp_pessoa: 1
                       , emi_cnpj_cpf_cuit: ''
                       , emi_ie: ''
                       , emi_nome: ''
                       , emi_cep: ''
                       , emi_numero: ''
                       , emi_bairro: ''
                       , emi_endereco: ''
                       , emi_municipio: []
                       , emi_complemento: ''
                       , des_tp_pessoa: 1
                       , des_cnpj_cpf_cuit: ''
                       , des_ie: ''
                       , des_nome: ''
                       , des_cep: ''
                       , des_numero: ''
                       , des_bairro: ''
                       , des_endereco: ''
                       , des_municipio: []
                       , des_complemento: ''
                       , des_pin: ''
                       , tp_doc: []
                       , num_fiscal: ''
                       , serie: ''
                       , dt_emissao: ''
                       , qtd_volume: ''
                       , peso_bruto: 0
                       , vlr_total_nfe: 0
                       , cep_busca: ''
                       , globalizado: 2
                       }),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.param_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Documento";
      this.modal_botao = "Editar Documento";
      this.modal_acao = "i";
      this.errors_array = '';
      this.errors_array = [];
      this.$parent.optionsMunicipios.forEach((obj)=>
      {
          this.optionsMunicipios.push({ label: obj.label, value: obj.value })
      })
      this.$parent.optionsLivTpPessoa.forEach((obj)=>
      {
          this.optionsLivTpPessoa.push({ text: obj.text, value: obj.value })
      })
      this.$parent.optionsLivDocFiscalTpDoc.forEach((obj)=>
      {
          this.optionsLivDocFiscalTpDoc.push({ label: obj.label, value: obj.value })
      })
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    calcCte() {

    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        if (this.helpForm.emi_cnpj_cpf_cuit != null) {
            this.helpForm.emi_cnpj_cpf_cuit = this.helpForm.emi_cnpj_cpf_cuit
              .replace(/[^a-zA-Z0-9]/g, "")
              .toUpperCase();
        }
        if (this.helpForm.des_cnpj_cpf_cuit != null) {
            this.helpForm.des_cnpj_cpf_cuit = this.helpForm.des_cnpj_cpf_cuit
              .replace(/[^a-zA-Z0-9]/g, "")
              .toUpperCase();
        }
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        if (this.helpForm.emi_cnpj_cpf_cuit != null) {
            this.helpForm.emi_cnpj_cpf_cuit = this.helpForm.emi_cnpj_cpf_cuit
              .replace(/[^a-zA-Z0-9]/g, "")
              .toUpperCase();
        }
        if (this.helpForm.des_cnpj_cpf_cuit != null) {
            this.helpForm.des_cnpj_cpf_cuit = this.helpForm.des_cnpj_cpf_cuit
              .replace(/[^a-zA-Z0-9]/g, "")
              .toUpperCase();
        }
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    ajustaMascara(tipo, origem){//Valor, destinatario/emitente, nfe/cte
        if(origem == 1)//NFE
        {
            if(tipo == 1)//Emitente
            {
                if(this.helpForm.emi_tp_pessoa == 1)//PF
                {
                    this.mascaraEmiNfe = "###.###.###-##";
                }
                if(this.helpForm.emi_tp_pessoa == 2)//PJ
                {
                    this.mascaraEmiNfe = "XX.XXX.XXX/XXXX-XX";
                }
                if(this.helpForm.emi_tp_pessoa == 3)//PO
                {
                    this.mascaraEmiNfe = "XXXXXXXXXXXXXXXX";
                }
            }
            if(tipo == 2)//Destinatario
            {
                if(this.helpForm.des_tp_pessoa == 1)//PF
                {
                    this.mascaraDesNfe = "###.###.###-##"
                }
                if(this.helpForm.des_tp_pessoa == 2)//PJ
                {
                    this.mascaraDesNfe = "XX.XXX.XXX/XXXX-XX";
                }
                if(this.helpForm.des_tp_pessoa == 3)//PO
                {
                    this.mascaraDesNfe = "XXXXXXXXXXXXXXXX";
                }
            }
        }
        if(origem == 2)//CTE
        {
            if(tipo == 2)//Destinatario
            {
                if(this.helpForm.des_tp_pessoa == 1)//PF
                {
                    this.mascaraDesCte = "###.###.###-##"
                }
                if(this.helpForm.des_tp_pessoa == 2)//PJ
                {
                    this.mascaraDesCte = "XX.XXX.XXX/XXXX-XX";
                }
                if(this.helpForm.des_tp_pessoa == 3)//PO
                {
                    this.mascaraDesCte = "XXXXXXXXXXXXXXXX";
                }
            }
        }

    },
    sanitizeDocPessoa(value) {
        if (value == null) {
            return "";
        }

        return value
          .toString()
          .replace(/[^a-zA-Z0-9]/g, "")
          .toUpperCase();
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
